module.exports = __webpack_public_path__ + "img/noti.5dc95cee.svg";